import { Box, Typography } from '@mui/material';


/**
 * Formats time in seconds to MM:SS string.
 * @param {number} time - Time in seconds.
 * @returns {string} Formatted time string.
 */
export const formatTime = (time) => {
  if (time === null || time === undefined || isNaN(time) || time < 0) return "00:00";
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
};


/**
 * Renders a labeled timer.
 * @param {Object} props - The component props.
 * @param {string} props.label - The label for the timer.
 * @param {number} props.timeSec - The time in seconds.
 * @param {Object} props.sx - The sx prop for the component.
 * @returns {JSX.Element} The rendered component.
 */
export const LabeledTimer = ({ label, timeSec, sx }) => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        background: 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(10px)',
        borderRadius: '16px',
        padding: '12px 20px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '120px',
        ...sx
      }}
    >
      <Typography
        variant="caption"
        sx={{
          display: 'block',
          fontWeight: 700,
          color: 'text.secondary',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          fontSize: '0.65rem',
          mb: 0.5
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 800,
          color: 'primary.main',
          fontFamily: "'Arimo', sans-serif",
          lineHeight: 1
        }}
      >
        {formatTime(timeSec)}
      </Typography>
    </Box>
  )
}
